/*
 * Módulo de frontend: página "S3 · Mantenimiento" (reglas de limpieza de buckets DO
 * Spaces, issue #2670). Standalone (no depende del catálogo). La config que se edita acá
 * la consume el workflow "S3: Sweep" de n8n vía GET /api/s3maintenance/targets.
 */
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';

const s3MaintenancePage = PageBlueprint.make({
  name: 's3-maintenance',
  params: {
    path: '/s3-mantenimiento',
    title: 'S3 · Mantenimiento',
    icon: <DeleteSweepIcon />,
    loader: () =>
      import('./S3MaintenancePage').then(m => <m.S3MaintenancePage />),
  },
});

export const s3MaintenanceModule = createFrontendModule({
  pluginId: 'app',
  extensions: [s3MaintenancePage],
});
